import React from "react";
// import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import "./VehicleComponent.css";

const VehicleComponent = ({ data }) => {
  // Get users from Redux store
  const users = useSelector((state) => state.users);

  const formatTrailerType = (type) => {
    if (!type) return "N/A";
    return type
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Function to get user alphacode by user_id
  const getUserAlphacode = (userId) => {
    if (!userId) return "N/A";

    // Find the user with the matching ID
    const user = Array.isArray(users)
      ? users.find(u => u.id === userId)
      : users[userId];

    // Return the alphacode if found, otherwise return the user_id
    return user ? user.alpha_code : userId.toString();
  };

  const rows = Array.isArray(data) ? data : [data];

  const renderRow = (row) => (
    <tr key={row?.id}>
      <td>{row?.company_owner}</td>
      <td>
        {row?.is_tray
          ? row?.tray_count
          : row?.is_loaded
          ? row?.load_number
          : "Empty"}
      </td>
      <td>
        {row?.last_inspection ? row.last_inspection.split('T')[0] : "N/A"} / {row?.next_inspection ? row.next_inspection.split('T')[0] : "N/A"}
      </td>
      <td>
        {row?.last_maintenance ? row.last_maintenance.split('T')[0] : "N/A"} / {row?.next_maintenance ? row.next_maintenance.split('T')[0] : "N/A"}
      </td>
      <td>{getUserAlphacode(row?.user_id)}</td>
      <td>{row?.red_tegged || (row?.is_loaded ? "Loaded" : "Empty")}</td>
      <td>{row?.trailer_location || "N/A"}</td>
      <td>{row?.trailer_number || "N/A"}</td>
      <td>{formatTrailerType(row?.type)}</td> {/* Format the type here */}
      <td className={`rounded-md tag ${
              row?.red_tagged ? "tag--red" : row?.yellow_tagged ? "tag--yellow" : ""
            }`}>{row?.tagged_description || "N/A"}</td>
    </tr>
  );

  return (
    <div className="trailer-table">
      <table>
        <thead>
          <tr>
            <th>Owner</th>
            <th>Load Number</th>
            <th>Inspections (Last / Next)</th>
            <th>Maintenance (Last / Next)</th>
            <th>Current User</th>
            <th>Status</th>
            <th>Location</th>
            <th>Trailer Number</th>
            <th>Type</th>
            <th>Tagged Description</th>
          </tr>
        </thead>
        <tbody>{rows.map(renderRow)}</tbody>
      </table>
    </div>
  );
};


export default VehicleComponent;
